import React from "react";
import sizun from "../../../assets/meditatingsizun.png"; // adjust path if needed
import { progressService } from "../../../services/progressService";
// adjust the relative path if needed


const EndSessionPopup = ({
  onEndSession,
  newSession,
  onClose,
  onExitSession,
  onSessionComplete,
  userId,
  subsectionId
}) => {
  const apiBaseURL = process.env.REACT_APP_BACKEND_API_URL;

  const handleExitAnyway = async () => {
    try {
      // End the session in backend
      if (newSession) {
        await fetch(`${apiBaseURL}/users/session/${newSession}/end`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
        });
      }

      // Close popup then move to next section
      onClose?.();

      if (typeof onSessionComplete === "function") {
        onSessionComplete();
        return;
      }

      // Mark section completed (fallback when no session-complete hook exists)
      if (userId && subsectionId) {
        await progressService.saveProgress(
          userId,
          subsectionId,
          { type: "ai", payload: {} },
          "completed"
        );
      }

      onExitSession?.();
    } catch (err) {
      console.error("Error during Exit Anyway:", err);
    }
  };


  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50">
      <div className="bg-white rounded-[26px] shadow-xl px-8 pt-[180px] pb-8 max-w-sm w-full text-center relative">

        {/* FLOATING SHIZUN */}
        <div className="absolute left-1/2 -translate-x-1/2 -top-20">
          <img
            src={sizun}
            alt="Shizun"
            className="w-[194px] h-[276px] object-contain"
          />
        </div>

        {/* TITLE */}
        <h2 className="text-[22px] font-gotham font-semibold text-gray-800 mb-2">
          Leaving now?
        </h2>

        {/* SUBTEXT */}
        <p className="text-gray-600 mb-8 text-[15px] leading-relaxed">
          What if your next insight was <br /> just one tap away?
        </p>

        {/* BUTTONS */}
        <div className="flex justify-center gap-3">
          <button
            onClick={onClose}
            className="px-6 py-3 bg-[#54B0AF] text-white rounded-full font-medium 
                 hover:bg-[#449e9d] transition-all duration-200 shadow-sm text-[15px]"
          >
            Stay & Discover
          </button>

          <button
            onClick={handleExitAnyway}
            className="px-6 py-3 bg-[#EDEDED] text-gray-700 rounded-full font-gotham font-medium 
                   hover:bg-gray-200 transition-all duration-200 shadow-sm text-[15px]"
          >
            Exit Anyway
          </button>
        </div>
      </div>
    </div>
  );
};

export default EndSessionPopup;
